import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { Router } from '@angular/router';
import { AppService } from '../../../../app.service';
import { PolicyDetailsVM, SiteCodes, WorkArea, Department } from '../../../GET_NEW_UI/entities/global/model';
import { DocumentLibraryService } from '../../../GET_NEW_UI/services/document-library.service';
import { ProgramImprovementService } from '../../../GET_NEW_UI/services/program-improvement.service';
import { PolicyProcedureService } from '../../../GET_NEW_UI/services/policy-procedure.service';
import { PreferencesService } from '../../../preferences/preferences.service';
import { MY_FORMATS } from '../../../rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { SafetyConfigService } from '../../services/safety-config.service';
import { FormControl, Validators } from '@angular/forms';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';

@Component({
  selector: 'app-search-policy-procedure',
  templateUrl: './search-policy-procedure.component.html',
  styleUrls: ['./search-policy-procedure.component.scss'],
    providers: [
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-au' }
  ],
})

export class SearchPolicyProcedureComponent implements OnInit {

  constructor(private _appService: AppService, private _router:Router,
    private _documentLibraryService:DocumentLibraryService,
    private _safetyConfigService:SafetyConfigService,
    private readonly _pref: PreferencesService,
    private _programImprovementService :ProgramImprovementService,
    private _policyProcedureService :PolicyProcedureService, ) { }

    StateList:SiteCodes[]=[];
    FileName:string=""
    SelectedDepartment:number[]=[];
    SelectedDepartment_=[];
    SelectedState_=[];
    SelectedState:number[]=[];
    SelectedWorkArea:number[]=[];
    SelectedWorkArea_=[];
   SearchResultsList: PolicyDetailsVM[]=[]
  startDate:Date 
  endDate:Date
  IsExapand:boolean=false;
  CopyStateList:SiteCodes[]=[]
  isSelectAllDepartment:boolean=false
  isSelectAllState:boolean=false
  isSelectAllWorkArea:boolean=false
  allworklist:WorkArea[]=[];
  filteredWorkList:WorkArea[]=[];
  allDepartmentList:Department[]=[];
  filteredwDepartmentlist:Department[]=[];
  loading:boolean=false;
  ngOnInit() {
    this._appService.setPageTitle('Search Policy Procedure');

    this.getStateList();
    this.getAllDepartmentAndWorkAreaList();
  }

  NavigateToCreatePolicyProcedureComponent(){
    this._router.navigate(['/create-policies-procedures']);
  }

ChangeExpand(sr:PolicyDetailsVM){
  sr.IsExpand = !sr.IsExpand
 
}

getAllDepartmentAndWorkAreaList(){
  this._safetyConfigService.GetDepartmentsAndWorkAreas().subscribe(res=>{ 
  this.allDepartmentList=res.Departments;
  this.allworklist=res.WorkAreas;  
  })
}

getStateList(){
  this._safetyConfigService.getAllSitesList().subscribe(sites =>
    { 
      this.StateList=sites;
      this.CopyStateList=sites;      
    });
}

selectAllState(ev) {
  let  arr=[]
   this.isSelectAllState = !this.isSelectAllState;
   if(this.isSelectAllState){
     for(let i=0; i<this.StateList.length; i++){
       arr.push(this.StateList[i].Id)
     } 
        this.buildStateFormControl.setValue(arr);
   } 
   else{
     this.buildStateFormControl.setValue([]);
     this.SelectedDepartment =[];
   }   
    this.SelectedState_=this.buildStateFormControl.value
    
    this.filteredwDepartmentlist = this.allDepartmentList.filter((el) => {
      return this.SelectedState_.some((f) => {
        return f === el.SiteId;
      });
    });
 };

 selectAllDepartment(ev) {
  let  arr=[]
   this.isSelectAllDepartment = !this.isSelectAllDepartment;
   if(this.isSelectAllDepartment){
     for(let i=0; i<this.filteredwDepartmentlist.length; i++){
       arr.push(this.filteredwDepartmentlist[i].ID)
     } 
        this.buildDepartmentFormControl.setValue(arr);
   } 
   else{
     this.buildDepartmentFormControl.setValue([]);
     this.SelectedWorkArea =[];
   }   
    this.SelectedDepartment_=this.buildDepartmentFormControl.value
    
    this.filteredWorkList = this.allworklist.filter((el) => {
      return this.SelectedDepartment_.some((f) => {
        return f === el.DepartmentID;
      });
    });
 };

 selectAllWorkArea(ev) {
  let  arr=[]
   this.isSelectAllWorkArea = !this.isSelectAllWorkArea;
   if(this.isSelectAllWorkArea){
     for(let i=0; i<this.filteredWorkList.length; i++){
       arr.push(this.filteredWorkList[i].ID)
     } 
        this.buildnoFormControl.setValue(arr);
   } 
   else{
     this.buildnoFormControl.setValue([]);
   }   
    this.SelectedWorkArea_=this.buildnoFormControl.value
 }

 stateChange(ID: number) {
  if (this.SelectedState_.indexOf(ID) > -1) {
    const pos = this.SelectedState_.indexOf(ID);
    this.SelectedState_.splice(pos, 1);
    const removeStateDeptList=this.filteredwDepartmentlist.filter(x=>x.SiteId==ID);
    for(let i = 0; i < removeStateDeptList.length; i++) {
      if (this.SelectedDepartment.indexOf(removeStateDeptList[i].ID) > -1){
        const position = this.SelectedDepartment.indexOf(removeStateDeptList[i].ID);
        this.SelectedDepartment.splice(position, 1);
      }
      }
  } else {
    this.SelectedState_.push(ID);
  }
  this.filteredwDepartmentlist = this.allDepartmentList.filter((el) => {
    return this.SelectedState_.some((f) => {
      return f === el.SiteId;
    });
  });
  this.SelectedWorkArea =[];
  this.filteredWorkList = [];
}
 
 departmentChange(ID: number) {
  if (this.SelectedDepartment_.indexOf(ID) > -1) {
    const pos = this.SelectedDepartment_.indexOf(ID);
    this.SelectedDepartment_.splice(pos, 1);
    const removeDeptWorkAreaList=this.filteredWorkList.filter(x=>x.DepartmentID==ID.toString());
    for(let i = 0; i < removeDeptWorkAreaList.length; i++) {
      if (this.SelectedWorkArea.indexOf(removeDeptWorkAreaList[i].ID) > -1){
        const position = this.SelectedWorkArea.indexOf(removeDeptWorkAreaList[i].ID);
        this.SelectedWorkArea.splice(position, 1);
      }
      }
  } else {
    this.SelectedDepartment_.push(ID);
  }
  this.filteredWorkList = this.allworklist.filter((el) => {
    return this.SelectedDepartment_.some((f) => {
      return f === el.DepartmentID;
    });
  });
}

 workAreaChange(ID: number) {
  if (this.SelectedWorkArea_.indexOf(ID) > -1) {
    const pos = this.SelectedWorkArea_.indexOf(ID);
    this.SelectedWorkArea_.splice(pos, 1);
  } else {
    this.SelectedWorkArea_.push(ID);
  }
}

RestFields(){
  this.SelectedState =[];
  this.startDate=null;
  this.endDate=null;
  this.SearchResultsList=[];
  this.endDate = null;
  this.startDate = null;
  this.StateList = this.CopyStateList
  this.SelectedDepartment =[];
  this.SelectedWorkArea =[];
}

buildStateFormControl = new FormControl("", [Validators.required]);
buildDepartmentFormControl = new FormControl("", [Validators.required]);
buildnoFormControl = new FormControl("", [Validators.required]);

searchPolicyProcedureDetails(){

  this.loading=true;
  this.SelectedDepartment=this.SelectedDepartment_;
    this.SelectedWorkArea=this.SelectedWorkArea_;
    this.SelectedState=this.SelectedState_;
  let model= new PolicyDetailsVM();
  model.IssuedDate=this.startDate==undefined?null:this.startDate;
  model.EndDate=this.endDate==undefined?null:this.endDate;
  model.StateIds=this.SelectedState
  model.DepartmentIds=this.SelectedDepartment
  model.WorkAreaIds=this.SelectedWorkArea
  console.log("search fileds", model)

  this._policyProcedureService.searchPolicyProcedureDetails(model).subscribe(res=>{
    this.loading=false;
    this.SearchResultsList = res
  })
}

onClickOpenForm(PolicyId) {

  if (PolicyId) {
      window.open('/create-policies-procedures/' + PolicyId, '_blank'); 
  } else { 
    window.open('/create-policies-procedures/');
  }
}

changeModelAutoComplete(event){
  const filterValue = event.target.value.toLowerCase();

  this.StateList = this.CopyStateList.filter(option => option.SiteName.toLowerCase().includes(filterValue));
}

}



